import styled, { css } from 'styled-components';
import { typographyTokenMapping, getTypographyStyles, getMargins } from '@oneaudi/unified-web-common';
import { FootnoteStyle } from '../text/index.styles.js';
export const StyledHeadline = styled.div `
  margin: ${(props) => getMargins(props.margin) || 0};
  text-align: ${(props) => props.$textAlign};

  ${(props) => {
    const { type, order } = props.variant;
    if (type === 'headline') {
        if (order === '1') {
            return css `
          color: ${props.theme.global.color.typography.headline.order1};
        `;
        }
        return css `
        color: ${props.theme.global.color.typography.headline.default};
      `;
    }
    return css `
      color: ${props.theme.global.color.typography.display.default};
    `;
}};

  ${(props) => {
    const { type, order, weight } = props.variant;
    const getTokenType = () => {
        if (type === 'headline') {
            return typographyTokenMapping.sys.typography[type]['order'][order][weight];
        }
        return typographyTokenMapping.sys.typography[type]['order'][order][weight];
    };
    return getTypographyStyles(getTokenType());
}};

  ${FootnoteStyle}
`;
//# sourceMappingURL=index.styles.js.map